import { useForm, Controller } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField, Checkbox } from '../../../../../components';
import {
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  Container,
  Dialog,
  Divider,
  Grid,
  IconButton,
  Paper,
  Stack,
  Tab,
  Tabs,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  calculateAge,
  dateFormatter,
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  getKeyPathValue,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { MLC } from '../../../../../constants';

const TABLE_HEADER = [
  {
    header: ' Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID No',
    accessor: 'uhid'
  },
  {
    header: 'Patient Name',
    accessor: (row) => {
      const status = row.status;
      return (
        <span
          style={{
            color: status === 'inactive' ? 'red' : 'black'
          }}
        >
          {`${row?.patient?.name}`}
        </span>
      );
    }
  },
  {
    header: 'Sponsor',
    accessor: 'patient.sponsor'
  },
  {
    header: 'Mobile No',
    accessor: 'patient.mobile_no'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const IPD_TABLE_COLUMNS = [
  {
    header: 'Adm No.',
    accessor: 'ipd_no'
  },
  {
    header: 'UHID',
    accessor: 'uhid'
  },
  {
    header: 'Adm Date',
    accessor: (row) => formatDate(row?.patient?.date)
  },
  {
    header: 'Patient Name',
    accessor: (row) => row?.patient?.name
  },
  {
    header: 'Department',
    accessor: (row) => row?.ipdpatient?.consultant_detail?.department?.department
  },
  {
    header: 'Ward',
    accessor: (row) => row?.ipdpatient?.consultant_detail?.room?.ward?.name
  },
  {
    header: 'Dis Date',
    accessor: (row) => formatDate(row?.ipdpatient?.dis_date)
  }
];

const ADD_Surgery = [
  {
    header: 'IPD No.',
    accessor: 'complaints'
  },

  {
    header: 'Patient Name',
    accessor: 'duration'
  },
  {
    header: 'Record By',
    accessor: 'duration'
  },
  {
    header: 'Adm. Date',
    accessor: 'duration'
  }
];

const ADD_Diagnosis = [
  {
    header: 'Document List',
    accessor: (row) => row?.deficiency_checklist
  },

  {
    header: 'Remarks',
    accessor: ''
  }
];

const initialOPDBillingDataObj = {
  data: [],
  loading: false
};

export const MRDFileRecieptVoucher = () => {
  const doctorIDRef = useRef();
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [opdBillingDataObj, setOpdBillingDataObj] = useState(initialOPDBillingDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [searchPatientRegisterationDialog, setSearchPatientRegisterationDialog] = useState(false);
  const [patientDetailList, setPatientDetailList] = useState([]);
  const [activeTab, setActiveTab] = useState(0);
  const [complaints, setComplaints] = useState([]);
  const [departmentDropdown, setDepartmentDropdown] = useState([]);
  const [medicineDetailList, setmedicineDetailList] = useState([]);
  const [diagnos, setDiagnos] = useState([]);
  const [input, setInput] = useState('');
  const [originalData, setOriginalData] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);
  const [pastComplaints, setPastComplaints] = useState([]);
  const [deficiencyChecklistDataObjs, setDeficiencyChecklistDataObjs] = useState([]);
  const [deficiencyChecklistDataObj, setDeficiencyChecklistDataObj] = useState([]);
  const [ipdRegistrationOpenDialogue, setIpdRegisterationOpenDialogue] = useState(false);
  const [juniorResidentDropwdown, setJuniorResidentDropdown] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [receiptStatus, setReceiptStatus] = useState('');

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        uhid: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: getCurrentDateTime('time'),
      recpt_date: new Date().toISOString().split('T')[0]
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const getDepartmentDropdown = useCallback(async () => {
    const data = await dropdownFetch('department');
    setDepartmentDropdown(data);
  }, []);

  useEffect(() => {
    getDepartmentDropdown();
  }, getDepartmentDropdown);

  useEffect(() => {
    if (selectedRecord) {
      const keyValuePair = getKeyPathValue(selectedRecord, 'bill', [
        '__v',
        '_id',
        'createdAt',
        'status',
        'service_items',
        'uhid',
        'complaints',
        'diagnos',
        'medicine',
        'vital'
      ]);
      keyValuePair.forEach(({ key, value }) => setValue(key, value));
      setValue('uhid', selectedRecord.uhid);
      setDetailList(selectedRecord.service_items);
      setComplaints(selectedRecord.complaints);
      setDiagnos(selectedRecord.diagnos);
      setmedicineDetailList(selectedRecord.medicine);
      setValue('date', getCurrentDateTime('date', selectedRecord.createdAt));
      setValue('time', getCurrentDateTime('time', selectedRecord.createdAt));
      searchPatientHandler(selectedRecord.uhid);
      if (selectedRecord?.vital) {
        setValue('vital.bp_sys', selectedRecord?.vital.bp_sys);
        setValue('vital.diastol', selectedRecord?.vital.diastol);
        setValue('vital.abdomen', selectedRecord?.vital.abdomen);
        setValue('vital.pulse', selectedRecord?.vital.pulse);
        setValue('vital.dm', selectedRecord?.vital.dm);
        setValue('vital.ihd', selectedRecord?.vital.ihd);
        setValue('vital.con_level', selectedRecord?.vital.con_level);
        setValue('vital.temp', selectedRecord?.vital.temp);
        setValue('vital.weight', selectedRecord?.vital.weight);
        setValue('vital.resp_rate', selectedRecord?.vital.resp_rate);
        setValue('vital.chest', selectedRecord?.vital.chest);
        setValue('vital.cvs', selectedRecord?.vital.cvs);
        setValue('vital.dre', selectedRecord?.vital.dre);
        setValue('vital.cns', selectedRecord?.vital.cns);
        setValue('vital.any_other', selectedRecord?.vital.any_other);
        setValue('vital.allergies', selectedRecord?.vital.allergies);
        setValue('vital.height', selectedRecord?.vital.height);
        setValue('vital.blood_group', selectedRecord?.vital.blood_group);
        setValue('vital.pallor', selectedRecord?.vital.pallor);
        setValue('vital.cyanos', selectedRecord?.vital.cyanos);
        setValue('vital.jvp', selectedRecord?.vital.jvp);
        setValue('vital.lymphade', selectedRecord?.vital.lymphade);
        setValue('vital.hydration', selectedRecord?.vital.hydration);
        setValue('vital.asthma', selectedRecord?.vital?.asthma);
        setValue('vital.icterus', selectedRecord?.vital?.icterus);
        setValue('vital.clubbing', selectedRecord?.vital?.clubbing);
        setValue('follow_up_date', selectedRecord?.follow_up_date);
        setValue('follow_up_days', selectedRecord?.follow_up_days);
        setValue('advice', selectedRecord?.advice);
        setValue('remarks', selectedRecord?.remarks);
      }
    } else {
      reset();
    }
  }, [selectedRecord]);

  const getJuniorResidentData = useCallback(async () => {
    const data = await dropdownFetch('junior-resident');
    setJuniorResidentDropdown(data);
  }, []);

  useEffect(() => {
    getJuniorResidentData();
  }, [getJuniorResidentData]);

  const formSubmit = async (formValues) => {
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/opd-requisition-edit' : '/opd-requisition-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...formValues,
        service_items: detailList,
        complaints: complaints,
        medicine: medicineDetailList,
        diagnos: diagnos
      }
    });
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} OPD Requisition`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} OPD Requisition`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleRowDelete = (rowId) => {
    setDetailList((prev) =>
      prev.filter((data) => {
        return data.service !== rowId;
      })
    );
  };

  const handleDeleteRecord = async () => {
    setLoading(true);
    const response = await request('/opd-requisition-delete', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully deleted OPD Requisition', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to delete OPD Requisition', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/opd-requisition-cancel', {
      method: 'DELETE',
      params: selectedRecord._id
    });
    if (response?.success) {
      toast('Successfully cancel OPD Requisition', { variant: 'success' });
      setSelectedRecord();
    } else {
      toast('Failed to cancel OPD Requisition', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setOpdBillingDataObj({ loading: true });
    const response = await request('/opd-requisition-list', { method: 'GET' });
    if (response.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      const filteredData = sortedData.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setOpdBillingDataObj({ loading: false, data: filteredData });
      setOriginalData(filteredData);
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setOpdBillingDataObj({ loading: false });
    }
  };

  const searchPatientHandler = async (uhid = null) => {
    if (typeof uhid !== 'number' && typeof uhid !== 'string') uhid = null;
    setLoading(true);
    const today = new Date().toISOString().split('T')[0];
    if (!uhid) setSearchPatientRegisterationDialog(true);
    const response = await request('/patient-registeration-searchdetail', {
      method: 'GET',
      query: { uhid }
    });
    if (response?.success) {
      if (uhid) {
        const {
          data: [patientData]
        } = response;
        setValue('visit', patientData.visit_no);
        setValue('op', patientData.op_no);
        setValue('patient_name', `${patientData.first_name} ${patientData.last_name}`);
        setValue('patient_suffix', patientData.name_suffix);
        setValue('opd_type', patientData.opd_type?.type);
        setValue('ref_type', patientData.ref_by?.referral_name);
        setValue('application_no', patientData.app_no_date);
        setValue('doctor', patientData.consultant?.name);
        doctorIDRef.current = patientData.consultant?._id;
        setValue('department', patientData.department?.department);
        setValue('patient_age', calculateAge(patientData?.dob));
        setValue('sponsor', patientData.sponsor?.name);
        setValue('remarks', patientData.remarks);
        setValue('queue_no', patientData.app_no_date);
        setValue('card_no', patientData.chq_card_no);
        setValue('vertical', patientData.vertical?.verticalname);
      } else {
        const todayData = response.data.filter(
          (patient) => new Date(patient.createdAt).toISOString().split('T')[0] === today
        );
        setPatientDetailList(todayData);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleActiveTab = (newTabIndex) => {
    setActiveTab(newTabIndex);
  };

  useEffect(() => {
    if (opdBillingDataObj.data && opdBillingDataObj.data.length > 0) {
      setOriginalData(opdBillingDataObj.data);
      setIsFiltered(false);
    }
  }, [opdBillingDataObj.data]);

  const handleUhidSearch = () => {
    const lowercasedInput = input.toLowerCase();
    console.log('HELLO BILLING DATA OBJ', opdBillingDataObj);
    const filtered = opdBillingDataObj.data.filter(
      (item) =>
        item?.uhid?.toString().toLowerCase().includes(lowercasedInput) ||
        item?.patient?.name?.toLowerCase().includes(lowercasedInput) ||
        item?.patient?.mobile_no?.toLowerCase().includes(lowercasedInput)
    );
    setOriginalData(filtered);
  };

  const handleChange = (e) => {
    const newInput = e.target.value;
    setInput(newInput);
    handleUhidSearch();
  };

  const handleFetchDeficiencyChecklists = async () => {
    setIpdRegisterationOpenDialogue(true);
    const response = await request('/deficiency-checklists-patient-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDeficiencyChecklistDataObjs({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDeficiencyChecklistDataObjs({ loading: false });
    }
  };

  const handleIpdRow = (row) => {
    setValue('ipd_no', row?.ipd_no);
    setValue('uhid', row?.uhid);
    setValue('ward', row?.ipdpatient?.consultant_detail?.room?.ward?.name);
    setValue('bed_no', row?.ipdpatient?.consultant_detail?.bed_no);
    setValue('department', row?.ipdpatient?.consultant_detail?.department?.department);
    setValue('patient_name', row?.patient?.name);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('gender', row?.patient?.gender);
    const formattedRegDate = row?.patient?.date ? new Date(row?.patient?.date).toISOString().split('T')[0] : '';
    setValue('adm_date', formattedRegDate);
    setValue('consultant', row?.ipdpatient?.consultant_detail?.doctor?.name);
    setValue('doctor_unit', row?.ipdpatient?.consultant_detail?.doctor?.doctor_unit?.unit);
    const formattedDisDate = row?.ipdpatient?.dis_date
      ? new Date(row?.ipdpatient?.dis_date).toISOString().split('T')[0]
      : '';
    setValue('discharge_date', formattedDisDate);
    setValue('mobile_no', row?.patient?.mobile);
    setSelectedRows(row?.checklist);
    setIpdRegisterationOpenDialogue(false);
  };

  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    if (!row || !field) {
      console.warn('Row data or field is undefined. Check the input.');
      return;
    }

    if (!Array.isArray(selectedRows)) {
      console.error('selectedRows is not an array:', selectedRows);
      setSelectedRows([]);
      return;
    }

    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        const updatedRows = prevSelectedRows.map((selectedRow) =>
          selectedRow._id === row._id ? { ...selectedRow, [field]: !existingRow[field] } : selectedRow
        );
        return updatedRows.filter((row) => row.ok || row.doc || row.Remarks?.trim());
      } else {
        return [
          ...prevSelectedRows,
          { _id: row._id, [field]: true, ok: field === 'ok', doc: field === 'doc', Remarks: row.Remarks || '' }
        ];
      }
    });
  };

  useEffect(() => {
    console.log('Selected rows have changed:', selectedRows);
  }, [selectedRows]);

  const handleInputChange = (rowId, field, value) => {
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === rowId);

      if (existingRow) {
        // Update the specific field in the existing row
        return prevSelectedRows.map((selectedRow) =>
          selectedRow._id === rowId ? { ...selectedRow, [field]: value } : selectedRow
        );
      } else {
        // Add a new row with the updated field
        return [...prevSelectedRows, { _id: rowId, [field]: value, ok: false, doc: false }];
      }
    });
  };
  const handleFetchDeficiencyChecklist = async () => {
    const response = await request('/deficiency-checklist-list', { method: 'GET' });
    if (response.success) {
      const filteredData = response.data.filter(
        (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
      );
      setDeficiencyChecklistDataObj({ loading: false, data: filteredData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setDeficiencyChecklistDataObj({ loading: false });
    }
  };
  useEffect(() => {
    handleFetchDeficiencyChecklist();
  }, []);

  const handleStatusChange = (event) => {
    setReceiptStatus(event.target.value);
  };

  console.log('HELLLO RECEPT STATUS', receiptStatus);

  return (
    <>
      <Paper sx={{ p: 0, flex: 1, borderRadius: 0, boxShadow: 'none' }}>
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 700 }}>
                MRD File Reciept Voucher
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction) || loading}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn id={'Exit'} variant="contained">
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Grid container spacing={2}>
              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Recpt. No/ Date
                  </Typography>
                  <TextField
                    disabled={!['new', 'edit'].includes(currentAction)}
                    sx={{ flex: 0.4 }}
                    name="recpt_no"
                    placeholder="Reciept No."
                  />
                  <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="" name="recpt_date" type="date" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Adm Date/ Time
                  </Typography>
                  <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="" name="adm_date" type="date" />
                  <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="" name="adm_time" type="time" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 600, fontSize: '1.4rem' }}>Mobile No.</Typography>
                  <TextField disabled={true} sx={{ flex: 0.8 }} placeholder="Mobile No" name="mobile_no" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 600, fontSize: '1.4rem' }}>Consultant</Typography>
                  <TextField sx={{ flex: 0.8 }} name="consultant" placeholder="Enter Name" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 600, fontSize: '1.4rem' }}>Discharge Type</Typography>
                  <TextField sx={{ flex: 0.8 }} name="dicharge_type" placeholder="" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.35, fontWeight: 600, fontSize: '1.4rem' }}>MLC </Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    name="mlc"
                    placeholder="Select MLC"
                    disabled={!['new', 'edit'].includes(currentAction)}
                    menus={MLC}
                  />
                </Stack>
              </Grid>
              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    IPD No.
                  </Typography>
                  <TextField disabled={true} sx={{ flex: 0.7 }} placeholder="" name="ipd_no" />
                  <Button
                    sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                    variant="contained"
                    onClick={() => handleFetchDeficiencyChecklists()}
                    disabled={!['new', 'edit'].includes(currentAction)}
                  >
                    <SearchIcon />
                  </Button>
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Patient Name</Typography>
                  <TextField sx={{ flex: 0.8 }} name="patient_name" placeholder="Enter Patient Name" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Ward / Bed No.</Typography>
                  <TextField sx={{ flex: 0.4 }} name="ward" placeholder="Enter ward" disabled />
                  <TextField sx={{ flex: 0.4 }} name="bed_no" placeholder="Enter bed" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Doctor Unit</Typography>
                  <TextField sx={{ flex: 0.8 }} name="doctor_unit" placeholder="Enter unit" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1rem', fontSize: '1.4rem' }}>
                    Dis. Date/Time
                  </Typography>
                  <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="" name="discharge_date" type="date" />
                  <TextField disabled={true} sx={{ flex: 0.4 }} placeholder="" name="discharge_time" type="time" />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Remarks</Typography>
                  <TextField
                    sx={{ flex: 0.8 }}
                    name="remarks"
                    placeholder="Enter remark"
                    disabled={!['new', 'edit'].includes(currentAction)}
                  />
                </Stack>
              </Grid>

              <Grid item xs={4} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>UHID</Typography>
                  <TextField sx={{ flex: 0.8 }} name="uhid" placeholder="Enter ward" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Age/ Gender</Typography>
                  <TextField sx={{ flex: 0.4 }} name="age" placeholder="Enter age" disabled />
                  <TextField sx={{ flex: 0.4 }} name="gender" placeholder="Enter gender" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>Department</Typography>
                  <TextField sx={{ flex: 0.8 }} name="department" placeholder="Enter department" disabled />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.3, fontWeight: 600, fontSize: '1.4rem' }}>JR. Resident</Typography>
                  <SelectTag
                    formControlSX={{ flex: 0.8 }}
                    disabled={!['new', 'edit'].includes(currentAction)}
                    name="jr_resident"
                    placeholder="select Jr Resident"
                    menus={juniorResidentDropwdown.map((data) => ({ ...data, name: data.junior_residentname }))}
                  />
                </Stack>
                <Stack spacing={0.5} direction="row" alignItems="center">
                  <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Receipt Status</Typography>
                  <RadioGroup
                    aria-label="receipt status"
                    name="receipt_status"
                    value={receiptStatus}
                    onChange={handleStatusChange}
                    sx={{ flex: 1 }}
                  >
                    <Box
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        '& > *': {
                          marginBottom: '8px'
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex' }}>
                        <FormControlLabel value="accepted" control={<Radio />} label="Accepted" />
                        <FormControlLabel
                          value="accepted without completion"
                          control={<Radio />}
                          label="Accepted Without Completion"
                        />
                      </Box>
                      <Box sx={{ display: 'flex' }}>
                        <FormControlLabel value="provisional" control={<Radio />} label="Provisional" />
                        <FormControlLabel value="rejected" control={<Radio />} label="Rejected" />
                      </Box>
                    </Box>
                  </RadioGroup>
                </Stack>
              </Grid>
              <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', minHeight: '20rem' }}>
                <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: '20rem' }}>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    size="small"
                    data={deficiencyChecklistDataObj?.data || []}
                    columns={ADD_Diagnosis}
                    showOk={true}
                    showDoc={true}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    showInputField={true}
                    handleInputChange={handleInputChange}
                    inputValues={inputValues}
                    selectedRows={selectedRows}
                  />
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 1, minHeight: '20rem' }}>
                  <Table
                    containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                    data={pastComplaints?.complaints || []}
                    columns={ADD_Surgery}
                    size="small"
                    onDeleteHandler={handleRowDelete}
                  />
                </Grid>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            OPD Requisition Query Window
          </Typography>

          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
            value={input}
            onChange={handleChange}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={originalData || []}
          loading={opdBillingDataObj.loading}
          onRowClick={(row) => {
            delete row.patient;
            setSelectedRecord(row);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={ipdRegistrationOpenDialogue}
        onClose={() => setIpdRegisterationOpenDialogue(false)}
        PaperProps={{ sx: { width: '70%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            IPD Patient Details
          </Typography>
          <IconButton onClick={() => setIpdRegisterationOpenDialogue(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack direction="row" spacing={2} alignItems="center" justifyContent="center" sx={{ mt: 0 }}>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0',
                fontSize: '1.4rem' // Adjust input font size
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 1.4rem'
              },
              '& .MuiInputLabel-root': {
                fontSize: '1.2rem' // Adjust label font size
              }
            }}
            label="Search Patient"
            variant="outlined"
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={IPD_TABLE_COLUMNS}
          data={deficiencyChecklistDataObjs.data || []}
          loading={deficiencyChecklistDataObjs.loading}
          onRowClick={(row) => {
            handleIpdRow(row);
          }}
        />
        ;
      </Dialog>
    </>
  );
};
